import React from 'react';
import { Select, MenuItem, Autocomplete, TextField } from '@mui/material';
import useStyles from '../../styles';
import { FileTypeConfig } from '../../../../../entities/file-type-configurations-v1/models';

const FileTypeSelect = ({
  selectId,
  fileTypeOptions,
  fileTypeValue,
  setValue,
  setLabel,
  value,
}: {
  selectId: string;
  fileTypeOptions: any[];
  fileTypeValue: string;
  setValue: Function;
  setLabel: Function;
  value: string;
}) => {
  const classes = useStyles();

  return (
    <Autocomplete
      id={selectId}
      className={classes.autoCompleteSelect}
      options={fileTypeOptions && fileTypeOptions}
      renderInput={(parameters) => <TextField variant="standard" {...parameters}/>}
      onChange={(event, newValue) => {
        if (newValue) {
          setValue(newValue.id as string);
          setLabel(newValue.label as string);
        }
        else {
          setValue('');
          setLabel('');
        }
      }}
      value={value}
      disableClearable={value === '' && true}
    />

  );
};

export default FileTypeSelect;